<template>
  <!-- <el-col :span="24" class="keep"> -->
  <div class="keep">
    <div class="banner_content">
      <div class="banner_box">
        <div class="banner_left">
          <img src="https://pic.joyorders.com/banner-left.png" style="height:100%;object-fit: contain;"/>
        </div>
        <div class="banner_right">
          <div class="title">全球优质买手汇聚</div>
          <!-- <div class="transition"></div> -->
          <div class="introduce">
            <!--<p>扫码进入JoyOrders小程序</p>-->
            <p>海淘代下单 商家原装发货</p>
            <div class="qrcode">
              <div style="width:120px;height:140px;padding:10px;border-radius: 3px;text-align: center;background:white;">
                <img src="https://pic.joyorders.com/banner-right.jpg" style="width:100px;height:100px;object-fit: contain;"/>
                <div style="font-size:12px;color:#333;margin-top:5px;">微信小程序</div>
              </div>
              <div style="margin-left:5px;width:120px;height:140px;padding:10px;border-radius: 3px;text-align: center;background:white;">
                <img :src="appUrl" style="width:100px;height:100px;object-fit: contain;transform: scale(1.12);"/>
                <div style="font-size:12px;color:#333;margin-top:5px;">安卓APP</div>
                <!--<img src="../../assets/images/AppLogo.png" style="position: absolute;width:15px;height:15px;left:35px;top:35px;border-radius: 50%;" />-->
              </div>
              <div style="margin-left:5px;width:120px;height:140px;padding:10px;border-radius: 3px;text-align: center;background:white;">
                <img :src="iosAppUrl" style="width:100px;height:100px;object-fit: contain;"/>
                <div style="font-size:12px;color:#333;margin-top:5px;">苹果APP</div>
              </div>
            </div>
          </div>
          
        </div>
        <!--<a @click="toCart" style="display: block">  <div class="btn">发布任务</div></a>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { BASE_HOST } from '../../services/constant'

  export default {
    name: 'Banner',
    components: {},
    data() {
      return {
        search: '',
        appUrl:BASE_HOST+'/static/joyorders_app_qrcode.png',
        iosAppUrl:BASE_HOST+'/static/iosapp.png',
        screenWidth: document.body.clientWidth
      }
    },
    methods:{
      toCart(){
        this.$router.push('/publish_task/cart')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .bg {
    background: url("../../assets/images/home-banner1.png") no-repeat;
    /*background: url("https://pic.joyorders.com/home-banner.png") center center no-repeat;*/
    height: 500px;
    max-width: 1440px;
    margin:144px auto 94px;
    .bannerbox{
      margin: 20px auto;
      padding-top: 70px;
      .bgcontent {
        width:100%;
        height:77px;
        font-size:20px;
        font-family:PingFangSC-Medium;
        color:rgba(255,255,255,1);
        line-height:34px;
        word-wrap:break-word;
        margin: 0 auto;
      }
      .title {
        width:220px;
        height:48px;
        font-size:34px;
        font-family:PingFangSC-Regular;
        color:rgba(255,255,255,1);
        line-height:48px;
        margin: 46px auto;
      }
      .transition {
        width:70px;
        height:3px;
        background:rgba(255,255,255,1);
        margin: 40px auto;
      }
      .introduce {
        text-align: center;
        max-width:646px;
        height:77px;
        font-size:18px;
        font-family:PingFangSC-Medium;
        color:rgba(255,255,255,1);
        line-height:25px;
        margin: 36px auto 0px;
      }
      .btn {
        text-align: center;
        margin: 35px auto;
        border-radius:3px;
        border:1px solid rgba(255,255,255,1);
        color:rgba(255,255,255,1);
        background-color: transparent;
        width:160px;
        height:46px;
        font-size:18px;
        line-height: 46px;
        font-family:PingFangSC-Regular;
      }
    }
  }
  .banner_content{
    /*background: url("../../assets/images/home-banner1.png") no-repeat;*/
    background: url("https://pic.joyorders.com/home-banner.png") center center no-repeat;
    height: 500px;
    max-width: 1440px;
    margin:144px auto 94px;
    .banner_box{
      display:flex;
      width:100%;
      height:100%;
      .banner_left{
        width:50%;
        text-align:right;
        img{
          width:354px;
        }
      }
      .banner_right{
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        color: white;
      }
      .title{
        font-size:34px;
        font-family:PingFangSC-Regular;
      }
      .introduce{
        font-size:18px;
        font-family:PingFangSC-Medium;
        margin-top: -50px;
        p{
          font-size:18px;
          line-height: 30px;
          letter-spacing: 3px;
        }
        .qrcode{
          margin-top:30px;
          display: flex;
          img{
            width:100px;
          }
        }
      }
    }
  }
  @media screen and (min-width:768px) and (max-width: 1024px) {
    .keep{
      max-width: 100%;
      .bg {
        margin: 48px auto;
        .btn {
        }
      }
    }
    .banner_content{
      margin-top:51px;
      margin-bottom:10px;
    }
  }
  @media screen and (max-width: 767px) {
    .keep{
      max-width: 100%;
      .bg {
        margin:0px auto;
        .titlebox {
          /*margin: 0 15px 0 15px;*/
        }
        .btn {
        }
      }
    }
    .banner_content{
      margin:0px auto;
      height: 450px;
      padding-top: 50px;
      .banner_box{
        .banner_left{
          img{
            width:220px;
          }
        }
        .banner_right{
          margin-left: 15px;
          .title{
            font-size:20px;
          }
          .introduce{
                font-size: 14px;
                p{
                   font-size: 11px;
                   line-height: 20px;
                   letter-spacing: 2px;
                }
          }
          .qrcode{
            margin-top:15px;
            img{
              width:60px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Banner.vue